import { render, staticRenderFns } from "./public-audio2.vue?vue&type=template&id=a147cec0&scoped=true&"
import script from "./public-audio2.vue?vue&type=script&lang=js&"
export * from "./public-audio2.vue?vue&type=script&lang=js&"
import style0 from "./public-audio2.vue?vue&type=style&index=0&id=a147cec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a147cec0",
  null
  
)

export default component.exports